import React, { useState } from 'react'
import PrimaryButton from '../../../jsx/components/button/primaryButton';
import { useDispatch } from 'react-redux';
import updateProOptionApi from '../../../service/api/user/updateProOption';
import { userById } from '../../../service/api/user/userById';
import { setLoaderTime, setTotalMonthlyFreeVideoLink, setUserDetails } from '../../../feature/userData/userData';
import ResponceToaster from '../../../jsx/components/responceToaster/responceToaster';

const ProOptionDashboard = ({setToggleForProOption}) => {
    const dispatch = useDispatch();

    const [updateProOptionLoading, setServiceReqOptionLoading] = useState(false);
    const [proOption, setProOption] = useState(0);

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState("");
    const [handleToaster, setHandleToaster] = useState(false);

    function handleGetUserById() {
        let user = {
            user_id_ids: localStorage.getItem("user_id"),
            role_id_int: localStorage.getItem("roleId"),
            user_impersonate_flag: 0,
        };
        dispatch(
            userById(user, (res) => {
                dispatch(setUserDetails(res.data.data));
                dispatch(setLoaderTime(res.data));
                dispatch(setTotalMonthlyFreeVideoLink(res.data))
                // setRoleArr(res.data.data.roles);
                // setChangedRoleId(res.data.data.role_id_int);
                // setRoleName(res.data.data.role_display_name_chr);
                // console.log(`${res.data.data.is_active_ysn} res.data.data.is_active_ysn`)
                localStorage.setItem("triggerFlag", res.data.data.is_available_ysn);
            })
        );
    }

    const handleSubmitProOption = (proOption = 0) => {

        setServiceReqOptionLoading(true);
        let data = new FormData();
        data.append('user_id_ids', localStorage.getItem('user_id'));
        data.append('pro_option', parseInt(proOption));

        dispatch(
            updateProOptionApi(data,
                (res) => {
                    setServiceReqOptionLoading(false);
                    setResponceMsg(res?.data?.message)
                    // setToasterType("success")
                    // setHandleToaster(true);
                    handleGetUserById();
                    setToggleForProOption(false);

                    // setTimeout(() => {
                    //   setHandleToaster(false);
                    // }, 5000);
                },
                (res) => {
                    setServiceReqOptionLoading(false);
                    setResponceMsg(res?.data?.message)
                    setToasterType("error")
                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 5000);
                })
        )

    }

    return (
        <>
            <div style={{}}>
                <div className="row" style={{ scrollMarginTop: "80px" }}>
                    <div className="col-12 px-md-5 px-lg-5 px-3 py-4 d-flex justify-content-center align-items-center flex-column">
                        <div className="fs-2 fw-bold mb-2 text-black text-center">
                            <span>A New Way To Turn Your Expertise Into </span>
                            <span className="text-primary">Earnings</span>
                        </div>

                        <div className="fs-5 text-center" style={{ maxWidth: '500px' }}>
                            <span>Join the Chilll network and help homeowners solve home repair problems — remotely or locally on-site.</span>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 px-md-5 px-lg-5 px-3 py-4 d-flex justify-content-center align-items-center">
                        <div className="row w-100" style={{ maxWidth: '1080px' }}>
                            <div
                                className="col-md-4 col-sm-12 p-3 d-flex justify-content-center align-items-center"
                            >
                                <div
                                    className="border rounded-2 border-hovered signup-pro-containers h-100"
                                    style={{ minHeight: '350px', maxWidth: '480px' }}
                                >
                                    <div
                                        className="d-flex justify-content-center align-items-center rounded-top"
                                        style={{ height: '170px', background: 'linear-gradient(135deg, #eef3f9 0%, #dde8f4 100%)', }}
                                    >
                                        <span className="fs-1">📋</span>
                                    </div>

                                    <div className="px-3 py-4">
                                        <div className="pb-1">
                                            <span
                                                className="px-2 py-1 font-w600"
                                                style={{ background: 'linear-gradient(135deg, #eef3f9 0%, #dde8f4 100%)', color: '#4a6fa5' }}
                                            >
                                                {`REMOTE`}
                                            </span>
                                        </div>

                                        <div className="py-1 fs-4 text-black font-w600">
                                            <span>{`Estimate Pro`}</span>
                                        </div>

                                        <div className="py-1">
                                            <span>{`Diagnose problems via video, give honest assessments, and deliver repair estimates — all from the comfort of home.`}</span>
                                        </div>

                                        <div className="text-black py-4">
                                            <div className="d-flex pb-1">
                                                <span
                                                    style={{ color: '#22c55e' }}
                                                    className="pe-2 fs-4"
                                                >
                                                    <i class="bi bi-check-circle-fill"></i>
                                                </span>
                                                <span>{`Earn $25 per 30-minute video estimate session`}</span>
                                            </div>

                                            <div className="d-flex pb-1">
                                                <span
                                                    style={{ color: '#22c55e' }}
                                                    className="pe-2 fs-4"
                                                >
                                                    <i class="bi bi-check-circle-fill"></i>
                                                </span>
                                                <span>{`Bonuses for high ratings & estimate accuracy`}</span>
                                            </div>

                                            <div className="d-flex pb-1">
                                                <span
                                                    style={{ color: '#22c55e' }}
                                                    className="pe-2 fs-4"
                                                >
                                                    <i class="bi bi-check-circle-fill"></i>
                                                </span>
                                                <span>{`Work on your own schedule — evenings, weekends, anytime`}</span>
                                            </div>

                                            <div className="d-flex">
                                                <span
                                                    style={{ color: '#22c55e' }}
                                                    className="pe-2 fs-4"
                                                >
                                                    <i class="bi bi-check-circle-fill"></i>
                                                </span>
                                                <span>{`Perfect for retired or senior pros with deep expertise`}</span>
                                            </div>
                                        </div>

                                        <div
                                            className='mt-2'
                                            style={{
                                                opacity: updateProOptionLoading ? 0.5 : 1,
                                                pointerEvents: updateProOptionLoading ? 'none' : 'auto'
                                            }}
                                        >

                                            <PrimaryButton
                                                buttonName={`Apply as Estimate Pro`}
                                                onClick={(e) => {
                                                    setProOption(3);
                                                    // scrollToSection(proFormRef);
                                                    handleSubmitProOption(3);
                                                }}
                                                isLoading={updateProOptionLoading && proOption === 3}
                                                loadingMessage={"Applying..."}
                                                style={{
                                                    // width: "100%",
                                                    background: '#4a6fa5',
                                                    border: '#4a6fa5',
                                                    // boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                    fontWeight: '600',
                                                }}
                                            />
                                        </div>

                                    </div>




                                </div>
                            </div>

                            <div
                                className="col-md-4 col-sm-12 p-3 d-flex justify-content-center align-items-center"
                            >
                                <div
                                    className="border  rounded-2 border-hovered signup-pro-containers h-100"
                                    style={{ minHeight: '350px', maxWidth: '480px' }}
                                >
                                    <div
                                        className="d-flex justify-content-center align-items-center rounded-top"
                                        style={{ height: '170px', background: 'linear-gradient(135deg, #fef3ed 0%, #fde4d4 100%)', }}
                                    >
                                        <span className="fs-1">🔧</span>
                                    </div>

                                    <div className="px-3 py-4">
                                        <div className="pb-1">
                                            <span
                                                className="px-2 py-1 font-w600"
                                                style={{ background: 'linear-gradient(135deg, #fef3ed 0%, #fde4d4 100%)', color: '#ff6b35' }}
                                            >
                                                {`REMOTE`}
                                            </span>
                                        </div>

                                        <div className="py-1 fs-4 text-black font-w600">
                                            <span>{`DIY Repair Pro`}</span>
                                        </div>

                                        <div className="py-1">
                                            <span>{`Coach homeowners through hands-on repairs via live video. Guide them step-by-step while they do the work.`}</span>
                                        </div>

                                        <div className="text-black py-4">
                                            <div className="d-flex pb-1">
                                                <span
                                                    style={{ color: '#22c55e' }}
                                                    className="pe-2 fs-4"
                                                >
                                                    <i class="bi bi-check-circle-fill"></i>
                                                </span>
                                                <span>{`Earn $25 per 30-minute video estimate session`}</span>
                                            </div>

                                            <div className="d-flex pb-1">
                                                <span
                                                    style={{ color: '#22c55e' }}
                                                    className="pe-2 fs-4"
                                                >
                                                    <i class="bi bi-check-circle-fill"></i>
                                                </span>
                                                <span>{`Bonuses for high customer ratings`}</span>
                                            </div>

                                            <div className="d-flex pb-1">
                                                <span
                                                    style={{ color: '#22c55e' }}
                                                    className="pe-2 fs-4"
                                                >
                                                    <i class="bi bi-check-circle-fill"></i>
                                                </span>
                                                <span>{`Use Chilll's built-in tools: drawing, measuring, parts sourcing`}</span>
                                            </div>

                                            <div className="d-flex">
                                                <span
                                                    style={{ color: '#22c55e' }}
                                                    className="pe-2 fs-4"
                                                >
                                                    <i class="bi bi-check-circle-fill"></i>
                                                </span>
                                                <span>{`Great for pros who want to teach and earn remotely`}</span>
                                            </div>
                                        </div>

                                        <div
                                            className='mt-2'
                                            style={{
                                                opacity: updateProOptionLoading ? 0.5 : 1,
                                                pointerEvents: updateProOptionLoading ? 'none' : 'auto'
                                            }}
                                        >
                                            <PrimaryButton
                                                buttonName={`Apply as DIY Repair Pro`}
                                                onClick={(e) => {
                                                    setProOption(2);
                                                    // scrollToSection(proFormRef);
                                                    handleSubmitProOption(2);
                                                }}
                                                isLoading={updateProOptionLoading && proOption === 2}
                                                loadingMessage={"Applying..."}
                                                style={{
                                                    // width: "100%",
                                                    background: '#ff6b35',
                                                    border: '#ff6b35',
                                                    // boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                    fontWeight: '600',
                                                }}
                                            />
                                        </div>

                                    </div>




                                </div>
                            </div>

                            <div
                                className="col-md-4 col-sm-12 p-3 d-flex justify-content-center align-items-center"
                            >
                                <div
                                    className="border rounded-2 border-hovered signup-pro-containers h-100"
                                    style={{ minHeight: '350px', maxWidth: '480px' }}
                                >
                                    <div
                                        className="d-flex justify-content-center align-items-center rounded-top"
                                        style={{ height: '170px', background: 'linear-gradient(135deg, #edf7ed 0%, #d4f0d4 100%)', }}
                                    >
                                        <span className="fs-1">🏠</span>
                                    </div>

                                    <div className="px-3 py-4">
                                        <div className="pb-1">
                                            <span
                                                className="px-2 py-1 font-w600"
                                                style={{ background: 'linear-gradient(135deg, #edf7ed 0%, #d4f0d4 100%)', color: '#2d8a4e' }}
                                            >
                                                {`ON-SITE`}
                                            </span>
                                        </div>

                                        <div className="py-1 fs-4 text-black font-w600">
                                            <span>{`Local Pro`}</span>
                                        </div>

                                        <div className="py-1">
                                            <span>{`Get matched with pre-qualified jobs in your area. Every lead comes with a video diagnosis — no wasted trips, no surprises.`}</span>
                                        </div>

                                        <div className="text-black py-4">
                                            <div className="d-flex pb-1">
                                                <span
                                                    style={{ color: '#22c55e' }}
                                                    className="pe-2 fs-4"
                                                >
                                                    <i class="bi bi-check-circle-fill"></i>
                                                </span>
                                                <span>{`Pre-qualified leads — see the problem before you accept`}</span>
                                            </div>

                                            <div className="d-flex pb-1">
                                                <span
                                                    style={{ color: '#22c55e' }}
                                                    className="pe-2 fs-4"
                                                >
                                                    <i class="bi bi-check-circle-fill"></i>
                                                </span>
                                                <span>{`No bidding wars or race to the bottom`}</span>
                                            </div>

                                            <div className="d-flex pb-1">
                                                <span
                                                    style={{ color: '#22c55e' }}
                                                    className="pe-2 fs-4"
                                                >
                                                    <i class="bi bi-check-circle-fill"></i>
                                                </span>
                                                <span>{`Homeowner already committed to schedule and price range`}</span>
                                            </div>

                                            <div className="d-flex">
                                                <span
                                                    style={{ color: '#22c55e' }}
                                                    className="pe-2 fs-4"
                                                >
                                                    <i class="bi bi-check-circle-fill"></i>
                                                </span>
                                                <span>{`Flat referral fee — you keep the rest`}</span>
                                            </div>
                                        </div>

                                        <div
                                            className='mt-2'
                                            style={{
                                                opacity: updateProOptionLoading ? 0.5 : 1,
                                                pointerEvents: updateProOptionLoading ? 'none' : 'auto'
                                            }}
                                        >

                                            <PrimaryButton
                                                buttonName={`Apply as Local Pro`}
                                                onClick={(e) => {
                                                    setProOption(1);
                                                    // scrollToSection(proFormRef);
                                                    handleSubmitProOption(1);
                                                }}
                                                isLoading={updateProOptionLoading && proOption === 1}
                                                loadingMessage={"Applying..."}
                                                style={{
                                                    // width: "100%",
                                                    background: '#2d8a4e',
                                                    border: '#2d8a4e',
                                                    // boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                    fontWeight: '600',
                                                }}
                                            />
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            {handleToaster && (
                <ResponceToaster toasterType={toasterType} message={responceMsg} />
            )}
        </>
    )
}

export default ProOptionDashboard;